<!-- <section class="on-bording">
    <div class="container">
        <div class="logo">
            <img src="assets/images/legance-white.svg" style="max-width: 300px" routerLink="" alt="logo">
        </div>
        <div class="login-box">
            <div class="box-header">
                <h3></h3>
            </div>
            <div class="supplier-registration">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</section> -->



<section class="rfqs-section">
        <router-outlet></router-outlet>
 </section>
